const Cities = () => (
  <div className="Cities">
    <h1>Cities</h1>
  </div>
)

export default Cities
